/*  ==========================================================================
    FREEROOMS LIST VIEW
    ========================================================================== */

/*
 * IMPORTS
 */

// node modules imports
import $ from 'jquery';
import 'jquery-inview';

// local imports
import * as vars from '../../globals/variables';
import * as utils from '../../utilities/utils';

/*
 * MODULE
 */

// hook function
function funcHook(container,data) {
}

// custom function
function funcCustom(container,data) {
}

// initialization
export function initFreeroomsListView($element) {
    let container = $element.find('.eh-service');

    // config
    let config = {
        addParams: {},
        container: container,
        funcCustom: funcCustom,
        funcHook: funcHook,
        type: 'freeroom',
        subtype: 'list-view'
    };

    // set a limit
    if ($(container).attr('data-limit')) {
        let limit = $(container).attr('data-limit');
        config.addParams.limit = limit;
    }

    // ehotelier service initialization (if element is in view)
    $element.one('inview', function() {
        utils.ehotelierLoader.initEhotlierService(config);
    });

}


// WEBPACK FOOTER //
// ./source/js/modules/lib/freerooms-list-view.js